import type { ComponentType } from "react";
import type { SectionType } from "../../types/template";
import { ClosingSection } from "../components/ClosingSection";
import { CountdownSection } from "../components/CountdownSection";
import { CoupleSection } from "../components/CoupleSection";
import { CoverSection } from "../components/CoverSection";
import { EventsSection } from "../components/EventsSection";
import { GallerySection } from "../components/GallerySection";
import { GiftSection } from "../components/GiftSection";
import { LiveStreamingSection } from "../components/LiveStreamingSection";
import { RsvpSection } from "../components/RsvpSection";
import { StorySection } from "../components/StorySection";
import { WishesSection } from "../components/WishesSection";
import type { SectionRenderProps } from "../renderer/types";

export const sectionRegistry: Record<SectionType, ComponentType<SectionRenderProps>> = {
  cover: CoverSection,
  couple: CoupleSection,
  story: StorySection,
  countdown: CountdownSection,
  events: EventsSection,
  rsvp: RsvpSection,
  gallery: GallerySection,
  gift: GiftSection,
  liveStreaming: LiveStreamingSection,
  wishes: WishesSection,
  closing: ClosingSection
};
